import * as React from 'react';
import Grid from '@mui/material/Grid';
import CardInspection from './InspectionCardMenu';

export default function InspectionMenuFrame() {
    return (
        <React.Fragment>
            < Grid sx={{ height: 64 }} />
            <CardInspection />
        </React.Fragment>
    );
}
